import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { UpdateReason } from 'APP/constants/scroll';
import Entities from 'STORE';
import { Group } from 'STORE/Groups/Group';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

interface ILoadBelowObserverPresenter {
  groupId: string;
  lastMessage: ChatMessage | null;
  group: Group | null;
  hasLoadBelowObserver: boolean;
  onInViewChange(isInView: boolean): void;
}

export const useLoadBelowObserverPresenter = (
  groupId: string,
  lastMessage: ChatMessage | null
): ILoadBelowObserverPresenter => {
  const presenter = useLocalObservable<ILoadBelowObserverPresenter>(() => ({
    groupId: groupId,
    lastMessage: lastMessage,

    get group(): Group | null {
      return Entities.GroupsStore.getGroupById(presenter.groupId);
    },

    get hasLoadBelowObserver(): boolean {
      const lastChatMessage = presenter.group?.messagesStore.getMessageByTs(
        presenter.group.lastMessageTs
      );
      const isRenderLastMessage =
        lastChatMessage &&
        presenter.lastMessage &&
        presenter.lastMessage.expectedServerTime >= lastChatMessage.expectedServerTime;

      return !isRenderLastMessage;
    },

    onInViewChange(isInView: boolean): void {
      if (isInView) {
        Entities.ChatStore.setScrollChanged(UpdateReason.LoadBelow);
      }
    },
  }));

  useEffect(() => {
    presenter.groupId = groupId;
  }, [groupId]);

  useEffect(() => {
    presenter.lastMessage = lastMessage;
  }, [lastMessage]);

  return presenter;
};
